(function(a){function d(e){0<e.clientY||(b&&clearTimeout(b),0>=a.exitIntent.settings.sensitivity?a.event.trigger("exitintent"):b=setTimeout(function(){b=null;a.event.trigger("exitintent")},a.exitIntent.settings.sensitivity))}function c(){b&&(clearTimeout(b),b=null)}var b;a.exitIntent=function(b,f){a.exitIntent.settings=a.extend(a.exitIntent.settings,f);if("enable"==b)a(window).mouseleave(d),a(window).mouseenter(c);else if("disable"==b)c(),a(window).unbind("mouseleave",d),a(window).unbind("mouseenter",
c);else throw"Invalid parameter to jQuery.exitIntent -- should be 'enable'/'disable'";};a.exitIntent.settings={sensitivity:300}})(jQuery);


jQuery( document ).ready( function() {
  var continue_checkout_accept = false;
  
  function getDomainName(url) {
    const a = document.createElement('a');
    a.href = url;
    return a.hostname;
  }
  
  function insertCurrentPageInHistory() {
    const stateData = { page: 'current-page' };
    const pageTitle = document.title;
    const currentURL = window.location.href;  
    history.pushState(stateData, "", currentURL);
  }

  // make slider clickable
  $('.hero__text-content').on('click', function(e) {e.preventDefault();window.location = $(this).find('a').attr('href');});
  $('.hero__image-wrapper').on('click', function(e) {e.preventDefault();let url = $(this).next().find('a').attr('href');if (url && url.length) {window.location=url;}});
  
  $(".breadcrumb-back").each(function(){
    
      const currentDomain = getDomainName(window.location.href);
      const referrerDomain = getDomainName(document.referrer);
    
      if (referrerDomain === currentDomain) {
          if( !this.href ){
            //$(this).attr("href", document.referrer);
            $(this).attr("href", $(this).attr("xhref"));
          }else{
            $(this).attr("href", $(this).attr("xhref"));
          }
      }else{
        $(this).attr("href", $(this).attr("xhref"));
      }
      $(this).click(function(e){
          //e.preventDefault();
          //insertCurrentPageInHistory();
          //history.go(-1);
      });
  });
  
  /*
  jQuery( 'body' ).on( 'submit', '#CartDrawer form, .cart-page-form', function ( evt ) {
    if ( ! continue_checkout_accept ) {
      evt.preventDefault();
      
      jQuery.getJSON('/cart.js', function( cart ) {
        console.log(cart);
        if ( cart.total_price > 80000 ) {
          jQuery( '#checkout-popup' ).addClass( 'show' );
        } else {
          continue_checkout_accept = true;
          jQuery( '#CartDrawer form .cart__checkout' ).click();
        }
      });
    }
  });

  jQuery( 'body' ).on( 'click', '#checkout-popup-continue-button', function ( evt ) {
    continue_checkout_accept = true;
    jQuery( '#CartDrawer form .cart__checkout' ).click();
    jQuery( '#checkout-popup' ).removeClass( 'show' );
  });

  jQuery( 'body' ).on( 'click', '#checkout-popup-cancel-button', function ( evt ) {
    jQuery( '#CartDrawer form .cart__checkout' ).removeClass( 'btn--loading' );
    jQuery( '#checkout-popup' ).removeClass( 'show' );
  });
  */
  
  
  /*if ( getCookie( 'cart_currency_force_selected' ) != 'true' ) {
    jQuery( '#currency-select-popup' ).addClass( 'show' );
  }
  
  jQuery( 'body' ).on( 'click', '#currency-select-popup .disclosure__toggle', function ( evt ) {
    evt.preventDefault();
    
    jQuery( this ).attr( 'aria-expanded', 'true' );
    jQuery( this ).next().addClass( 'disclosure-list--visible' );
  });
  
  
  jQuery( 'body' ).on( 'click', '#currency-select-popup .disclosure-list__option', function ( evt ) {
    evt.preventDefault();
    
    jQuery( '#currency-select-popup input[name="currency_code"]' ).val( jQuery( this ).data( 'value' ) );
    jQuery( this ).parents( 'form' ).submit();
    
    document.cookie = 'cart_currency_force_selected=true;';
  });*/


  
//POPUP MANUAL TRIGGER
//POPUP MANUAL TRIGGER
//POPUP MANUAL TRIGGER

jQuery( document ).ready( function() {

    if(jQuery.exitIntent){
        jQuery.exitIntent('enable');  
    }
    
    var popupshown = false;
    var popupcookie = getCookie('explorepop');
    var popupdisable = getCookie('popupdisable');
    var countcookie = getCookie('explorecount');
    var exitshown = false;
    //jQuery('body').append("<div class='' style=''>"+popupcookie+"</div>");
    if (countcookie == "") {
        setCookie('explorecount', 1, 1);
        countcookie = 1;
    } else if (countcookie == 1) {
        setCookie('explorecount', 2, 1);
        countcookie = 2;
    } else {
        countcookie = parseInt(countcookie) + 1;
        setCookie('explorecount', countcookie, 1);
    }
    console.log("popupdisable: " + popupdisable);

    function showWelcomePopup() {

      if (popupdisable != 1) {
        setCookie('popupdisable', 1, 1);
        popupdisable = getCookie('popupdisable');

      console.log("WELCOME POPUP");
      $('.welcome-popup-modal').removeClass('hidden');
        console.log("popupdisable: " + popupdisable);
      }

      //if( jQuery(".welcome-popup").length > 0 ){
      // if( jQuery(".welcome-popup").length > 0 && !exitshown){

      //     // console.log("WELCOME POPUP");
      //     // jQuery('body').append("<div class='trigger-popup' style='display: none;'></div>");
      //     // jQuery(".powr-popup").remove();
      //     // jQuery(".powr-popup-script").remove();
      //     // var xid = jQuery(".welcome-popup").attr("xid");
  
      //     // jQuery('body').append("<div class='powr-popup welcome-popup' id='"+xid+"'></div>");

      //     // var script = document.createElement('script');
      //     // script.className = 'powr-popup-script';
      //     // script.src = 'https://www.powr.io/powr.js?platform=shopify';
      //     // script.onload = function() {
      //     //   setTimeout(function(){
      //     //     jQuery('.trigger-popup').click();
      //     //   }, 300)
      //     // };
      //     // document.body.appendChild(script);
          
      // }
    }
    function showExitPopup() {
      //console.log("Exit exitshown " + exitshown);
      //if( jQuery(".wait-popup").length > 0 && !exitshown){
      if( jQuery(".wait-popup").length > 0 ){
          console.log("Exit POPUP");
          jQuery('body').append("<div class='trigger-popup' style='display: none;'></div>");
          jQuery(".powr-popup").remove();
          jQuery(".powr-popup-script").remove();
          var xid = jQuery(".wait-popup").attr("xid");
  
          jQuery('body').append("<div class='powr-popup exit-popup' id='"+xid+"'></div>");

          var script = document.createElement('script');
          script.className = 'powr-popup-script';
          script.src = 'https://www.powr.io/powr.js?platform=shopify';
          script.onload = function() {
            setTimeout(function(){
              jQuery('.trigger-popup').click();
            }, 300)
          };
          document.body.appendChild(script);
                 

          exitshown = true;
      }
    }

    $(document).keypress(function(event) {
        console.log(event.key);        
        console.log(event.altKey);         
        console.log(event.shiftKey);         
        if (event.shiftKey && event.key === '!') {
            showWelcomePopup();
        }    
        // if (event.key === '2') {
        //     //showExitPopup();
        //     //showWelcomePopup();
        // }
        // if (event.key === '3') {
        //   console.log(popupshown);
        //   console.log(popupcookie);
        //   console.log(countcookie);
        //   console.log(exitshown);
        // }
    });
    
    //console.log("countcookie: " + countcookie);
    setTimeout(function() {
      if (jQuery(window).width() <= 991) {
        if (countcookie % 2 == 0) {
          //showExitPopup();
          showWelcomePopup();
        }else{
          showWelcomePopup();
        }        
      }else{
        showWelcomePopup();
      }
    }, 7000);


    /*
    
    //console.log("countcookie: " + countcookie);
    // setTimeout(function() {
    //   if (jQuery(window).width() <= 991) {
    //     if (countcookie % 2 == 0) {
    //       //showExitPopup();
    //       showWelcomePopup();
    //     }else{
    //       showWelcomePopup();
    //     }        
    //   }else{
    //     showWelcomePopup();
    //   }
    // }, 7000);


function startFloatingTimer(startTime) {
  var timerEl = document.createElement("div");
  timerEl.id = "floating-timer";
  timerEl.style.position = "fixed";
  timerEl.style.top = "10px";
  timerEl.style.right = "10px";
  timerEl.style.padding = "6px 10px";
  timerEl.style.background = "rgba(0,0,0,0.7)";
  timerEl.style.color = "#fff";
  timerEl.style.fontSize = "12px";
  timerEl.style.borderRadius = "4px";
  timerEl.style.zIndex = "9999";
  timerEl.style.fontFamily = "monospace";
  timerEl.innerText = "0.0s";

  document.body.appendChild(timerEl);

  var interval = setInterval(function () {
    function getElapsed() {
      if (finalElapsed !== null) {
        return finalElapsed;
      }
      return (Date.now() - startTime) / 1000;
    }
    var elapsed = (Date.now() - startTime) / 1000;
    timerEl.innerText = (popupShown ? "Popup: "+ triggerSource + "\n" : "") + (isMobile ? "Mobile" : "Desktop") +
    (popupShown ? "\nScroll: " + (scrollData + 0).toFixed(1) + "%\n" + finalTime.toFixed(1) + "s" : "\nScroll: " + (scrollData + 0).toFixed(1) + "%\n" + elapsed.toFixed(1) + "s")
     ;
  }, 100);

  return {
    stop: function () {
      clearInterval(interval);
      timerEl.remove();
    }
  };
}

var popupShown = false;
var finalTime = null;
var startTime = Date.now();
var triggerSource = "";
var scrollData = 0;
if (new URLSearchParams(window.location.search).has('popupdebug')) {
    var timer = startFloatingTimer(startTime);
}

function tryShowPopup(source) {
  if (popupShown) return;
  if (Date.now() - startTime < 5000) return;
  popupShown = true;
  finalTime = (Date.now() - startTime) / 1000;
  triggerSource = source;
  showWelcomePopup();
}

$(document).keypress(function(event) {
    console.log(event.key);        
    if (event.key === '1') {
        showWelcomePopup();
    }
    if (event.key === '2') {
        tryShowPopup("keypress");
    }
    if (event.key === '3') {
      console.log(popupShown);
    }
});

var isMobile = jQuery(window).width() <= 991;

// --- MOBILE
if (isMobile) {

  var mobileTimerDone = false;
  var mobileScrollDone = false;

  setTimeout(function () {
    mobileTimerDone = true;
    if (mobileScrollDone) tryShowPopup("mobile timeout after 50%");
  }, 15000);

  jQuery('.slideshow-wrapper + .text-slider-container').on('click', function() {
    tryShowPopup("mobile manual");
  });

  jQuery(window).on("scroll", function () {
    var scrollTop = jQuery(window).scrollTop();
    var docHeight = jQuery(document).height() - jQuery(window).height();
    var scrollPercent = (scrollTop / docHeight) * 100;
    scrollData = scrollPercent;

    if (scrollPercent >= 50) {
      mobileScrollDone = true;
      if (mobileTimerDone) tryShowPopup("mobile scrollPercent");
    }
  });

// --- DESKTOP
} else {

  jQuery(document).on("mouseleave", function (e) {
    if (e.clientY <= 0) {
      tryShowPopup("exit intent");
    }
  });

  setTimeout(function () {
    tryShowPopup("desktop timeout");
  }, 10000);

  jQuery(window).on("scroll", function () {
    var scrollTop = jQuery(window).scrollTop();
    var docHeight = jQuery(document).height() - jQuery(window).height();
    var scrollPercent = (scrollTop / docHeight) * 100;
    scrollData = scrollPercent;

    if (scrollPercent >= 40) {
      tryShowPopup("desktop scrollPercent");
    }
  });
}
*/
  
    // console.log(countcookie);
    
    // if (countcookie == 2) {
    //     // setTimeout(function() {
    //     //     setPopupTrigger();
    //     // }, 1500);
    //     if (jQuery(window).width() <= 991) {
    //         setTimeout(function() {
    //             setPopupTrigger();
    //             if (popupcookie != 1) { }
    //         }, 14000)
    //     }
    // }
    // if (countcookie == 1) {
    //     setTimeout(function() {
    //         setPopupTrigger();
    //     }, 5000)
    // }
    
    // jQuery(document).bind('exitintent',
    //     function() {
    //         // console.log("exit C" + countcookie + " pop: " + popupshown + jQuery(window).width());
    //         if (jQuery(window).width() > 991) {
    //             if(countcookie > 1){
    //               //showExitPopup();
    //               showWelcomePopup();
    //             }
    //             if (popupcookie != 1) {
    //             }
    //         }
    //     }
    // );
});


  // BEST SELLERS SCROLL
  // BEST SELLERS SCROLL
  $(".best-sellers-block .slider-blocks .slider-inner").each(function(){
        var ele = $(this)[0];
    
        let pos = { top: 0, left: 0, x: 0, y: 0 };
    
        const mouseDownHandler = function (e) {
            pos = {
                // The current scroll
                left: ele.scrollLeft,
                top: ele.scrollTop,
                // Get the current mouse position
                x: e.clientX,
                y: e.clientY,
            };
            ele.style.cursor = 'grabbing';
            ele.style.userSelect = 'none';
        
            ele.addEventListener('mousemove', mouseMoveHandler);
            ele.addEventListener('mouseup', mouseUpHandler);
        };
    
        const mouseMoveHandler = function (e) {
            // How far the mouse has been moved
            const dx = e.clientX - pos.x;
            const dy = e.clientY - pos.y;
        
            // Scroll the element
            ele.scrollTop = pos.top - dy * 1.5;
            ele.scrollLeft = pos.left - dx * 1.5;
        };
        const mouseUpHandler = function () {
            ele.removeEventListener('mousemove', mouseMoveHandler);
            ele.removeEventListener('mouseup', mouseUpHandler);
        
            ele.style.cursor = 'grab';
        };
    
        ele.addEventListener('mousedown', mouseDownHandler);
        
    });


  jQuery( document ).on( 'ajaxProduct:added', function ( evt ) {
    var product = evt.detail.product;
    
    gtag('event', 'add_to_cart', {
        currency: current_currency,
        value: ( product.price / 100 ).toFixed( 2 ),
        items: [
          {
            item_id: product.id,
            item_name: product.title,
            currency: current_currency,
            index: 0,
            item_brand: product.vendor,
            price: ( product.price / 100 ).toFixed( 2 ),
            quantity: 1
          }
        ]
    });
  });

  jQuery( document ).on( 'cart:updated', function ( evt ) {
    console.log('Cart Updated!');
    //console.log(evt.detail);
    //console.log( data );
    //console.log( evt.detail.cart.item_count );
    jQuery( ".cart-link__bubble" ).html(evt.detail.cart.item_count);
  });


  jQuery( 'a.site-nav__link[href*="sale"], a.mobile-nav__link[href*="sale"]' )
  .on( 'click', function ( evt ) {
    console.log("sale");
    gtag('event', 'menu_click_sale', {});
  });
  jQuery( 'a.site-nav__link[href*="faqs"], a.mobile-nav__link[href*="faqs"]' )
  .on( 'click', function ( evt ) {
    console.log("faqs");
    gtag('event', 'menu_click_faq', {});
  });
  jQuery( 'a.site-nav__link[href*="samples"], a.mobile-nav__link[href*="samples"]' )
  .on( 'click', function ( evt ) {
    console.log("samples");
    gtag('event', 'menu_click_free_samples', {});
  });
  jQuery( 'a.site-nav__link[href*="our-story"], a.mobile-nav__link[href*="our-story"]' )
  .on( 'click', function ( evt ) {
    console.log("our-story");
    gtag('event', 'menu_click_our_story', {});
  });
  jQuery( 'a.site-nav__link[href*="contact-us"], a.mobile-nav__link[href*="contact-us"]' )
  .on( 'click', function ( evt ) {
    console.log("contact-us");
    gtag('event', 'menu_click_contact', {});
  });
  jQuery( 'a.site-nav__link[href*="collab"], a.mobile-nav__link[href*="collab"]' )
  .on( 'click', function ( evt ) {
    console.log("collab");
    gtag('event', 'menu_click_collab', {});
  });
  jQuery( 'a.site-nav__link[href*="gallery"], a.mobile-nav__link[href*="gallery"]' )
  .on( 'click', function ( evt ) {
    console.log("gallery");
    gtag('event', 'menu_click_gallery', {});
  });
  jQuery( 'a.site-nav__link[href*="trade"], a.mobile-nav__link[href*="trade"]' )
  .on( 'click', function ( evt ) {
    console.log("trade");
    gtag('event', 'menu_click_trade', {});
  });
  jQuery( 'a.site-nav__link[href*="collections"], a.mobile-nav__link[href*="collections"]' )
  .on( 'click', function ( evt ) {
    console.log("collections");
    gtag('event', 'menu_click_collections', {});
  });

  
});

function getCookie ( cookie_name ) {
  var cookie_row = document.cookie.split('; ').find( row => row.startsWith( cookie_name + '=' ) );
  
  return typeof cookie_row === 'string' ? cookie_row.split('=')[1] : '';
}


function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}







function frStrings(){
    jQuery("[class*='HeaderTitle__Text']:contains(Overall Rating)").each(function(){
        var txt = jQuery(this).html().replace(/Overall Rating/g, "L'avis de notre clientèle");
        jQuery(this).html(txt);
    });
    jQuery("[class*='HeaderTitle__Text']:contains(Explore Hardware Rating)").each(function(){
        var txt = jQuery(this).html().replace(/Explore Hardware Rating/g, "Classement D'Explore Hardware");
        jQuery(this).html(txt);
    });
    jQuery("[class*='HeaderTitle__Text']:contains(Rating)").each(function(){
        var txt = jQuery(this).html().replace(/Rating/g, "avis");
        jQuery(this).html(txt);
    });
    jQuery("[class*='ButtonBase__Ellipsis']:contains(Write a Review)").each(function(){
        var txt = jQuery(this).html().replace(/Write a Review/g, "Écrire un avis");
        jQuery(this).html(txt);
    });      
    jQuery("[class*='TabTitle__Container']:contains(All Reviews)").each(function(){
        var txt = jQuery(this).html().replace(/All Reviews/g, "Tous les avis");
        jQuery(this).html(txt);
    });




    jQuery(".spr-badge-caption:contains(reviews)").each(function(){
        var txt = jQuery(this).html().replace(/reviews/g, "avis");
        jQuery(this).html(txt);
    });
    jQuery(".spr-badge-caption:contains(review)").each(function(){
        var txt = jQuery(this).html().replace(/review/g, "avis");
        jQuery(this).html(txt);
    });
    jQuery(
        ".spr-badge-caption:contains(critiques)"
        +","+
        ".spr-summary-actions-togglereviews:contains(critiques)"
      ).each(function(){
        var txt = jQuery(this).html().replace(/critiques/g, "avis");
        jQuery(this).html(txt);
    });
    jQuery(
        ".spr-badge-caption:contains(critique)"          
        +","+
        ".spr-summary-actions-togglereviews:contains(critique)"
      ).each(function(){
        var txt = jQuery(this).html().replace(/critique/g, "avis");
        jQuery(this).html(txt);
    });

    jQuery("p:contains(Usually ships within 2 weeks)").each(function(){
        var txt = jQuery(this).html().replace(/Usually ships within 2 weeks/g, "Généralement expédié en deux semaines");
        jQuery(this).html(txt);
    });


    jQuery(
        ".ga-product_addtocart:contains(Add to cart)"
      ).each(function(){
        var txt = jQuery(this).html().replace(/Add to cart/g, "Ajouter au panier");
        jQuery(this).html(txt);
    });

  
  

  
};
if( $("html").attr('lang') == "fr" ) {
    setInterval(function(){ frStrings(); },500);
    frStrings();
}



if( jQuery(window).scrollTop() > 250 ) {
    jQuery('body').addClass('sticky-header');
}
jQuery(window).on('scroll', function(e){
    if ( jQuery(this).scrollTop() > 250 ) {
        jQuery('body').addClass('sticky-header');
    } else {
        jQuery('body').removeClass('sticky-header');
    }
});

//SALE COUNTDOWN TOP BANNER
//SALE COUNTDOWN TOP BANNER
//SALE COUNTDOWN TOP BANNER

function countDownTimer() {
    // 1662555600000
    // 1662523200000
    // <t:1662523200>
  const difference = +new Date(1662523200000) - +new Date();
  let remaining = "";

  if (difference > 0) {
    const parts = {
        //   days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      H: Math.floor((difference / (1000 * 60 * 60)) % 24),
      m: Math.floor((difference / 1000 / 60) % 60),
      s: Math.floor((difference / 1000) % 60),
    };
    remaining = Object.keys(parts).map(part => {
        var p = parts[part];
        if(p < 10){
            p = "0" + p;
        }
        if(part == "m"){
            p = p + ":";
        }
        if(part == "H"){
            p = p + ":";
        }
        return `${p}`;
    }).join("");
  }
  $(".announcement__text .countdown").html(remaining);
}

setInterval(() => {
    //countDownTimer();
}, 500);



// FIX CART RECOMMENDED
$(".ga_cart_upsell_wp a[target='_blank']").attr( 'target', '' );
setInterval(() => {    
    $(".ga_cart_upsell_wp a[target='_blank']").attr( 'target', '' );
}, 500);



// UNBIND DEFAULT SEARCH FROM SEARCHBAR, FIX CURRENCY ISSUE
function unbindDefaultSearch() {
  $(".site-header__search form").unbind('submit');
  var sform = $(".template-product #HeaderSearchForm").not(".sform").clone();
  if(typeof sform !== 'undefined'){
    sform.addClass("sform");
    $(".template-product #HeaderSearchForm").not(".sform").after(sform);
    $(".template-product #HeaderSearchForm").not(".sform").remove();
  }
  
};
setTimeout(() => {
  unbindDefaultSearch();
}, 500);

// ADD FIX FOR SEARCHBAR AJAX RESULTS
setInterval(function(){
    $(".predictive-results__footer button").unbind("click");
    $(".predictive-results__footer button").bind("click", function(){
        $(".site-header__search-form").submit();
    });
    $(".predictive-result__layout a.predictive__result:not('.ccy')").each(function(){
        var currency = $(".site-header__search-form").attr("currency");
        if(currency == "USD"){
            $(this).addClass("ccy").attr("href", "/en-us" + $(this).attr("href"))
        }
    })
},500);



// MOVE VISITOR COUNTER BELOW THE PRODUCT TITLE
/*
function moveBelowTitle() {
  console.log("moveBelowTitle")
  const elementToMove = document.getElementById('effectiveAppsProductVisitorsCounterElement');
  const titleElement = document.querySelector('.product-single__title');
  if (elementToMove && titleElement) {
    titleElement.parentNode.insertBefore(elementToMove, titleElement.nextSibling);
    elementToMove.classList.add('moved');
    var xval = $("#effectiveAppsProductVisitorsCounterElement > p > span")
    var xeye = xval.find(".ql-emojiblot").clone();
    xval.find(".ql-emojiblot").remove();
    var xcount = parseInt(xval.html());
    if(xcount < 10){ xcount += 100; }
    xval.html(xcount).prepend(xeye);
  }
}
var moveBelowTitleintervalId;
var moveBelowCount = 0;
window.addEventListener('load', function(){
  moveBelowTitleintervalId = setInterval(() => {
    moveBelowTitle();
    moveBelowCount++;
    if (moveBelowCount >= 3) {
      clearInterval(moveBelowTitleintervalId);
    }
  }, 1000);
  moveBelowTitle();  
});
*/





jQuery( document ).ready( function() {
    $(".product-single__form").click(function(){
      setTimeout(function(){
        var xmoney = $('.fprice .money').html();
        xmoney = parseInt(xmoney.replace(/\$|\.|\,/g, ''));
        $('.affirm-as-low-as').attr("data-amount",xmoney);
        affirm.ui.refresh();
      },300)
    })
  
});
  
$(document).bind('keypress', function(e) {
    //console.log(e.keyCode);
    if (e.keyCode == 50) {
        //console.log("refresh");
        //setCookie('explorepop', "", 0);
        setCookie('tawktodisable', "", -1);
        //affirm.ui.refresh();
    }
    if (e.keyCode == 49) {
        setCookie('tawktodisable', 'true', 1);
        //setPopupTrigger();
    }
});

function tawktodisabler() {
  return;
  //console.log(getCookie( 'tawktodisable' ))
  if ( getCookie( 'tawktodisable' ) != 'true' ) {
    jQuery(".widget-visible").removeClass("widget-hidden");
  }else{
    jQuery(".widget-visible").addClass("widget-hidden");
  }
  
  var xstyle = jQuery(".widget-visible iframe").attr("style");
  jQuery(".widget-visible[id]").removeAttr("id").prepend("<div class='widget-hide'><div class='widget-close'></div></div>");
  jQuery(".widget-hide").attr("style",xstyle)
  jQuery(".widget-close").click(function(){
      setCookie('tawktodisable', 'true', 1);
      jQuery(".widget-visible").addClass("widget-hidden");
  });
}

jQuery( document ).ready( function() {
  tawktodisabler();
  setInterval(() => {
      tawktodisabler();
  }, 500);
});


$ = jQuery;

$(document).ready(function() {


  
  var modal2 = $("#myModal2");
  var btn2 = $("#myBtn2");
  var span = $(".close").eq(0);

  if (btn2.length > 0) {
    btn2.on("click", function() {
      modal2.css("display", "block");
    });
  }
  span.on("click", function() {
    modal2.css("display", "none");
  });
  $(window).on("click", function(event) {
    if (event.target === modal2[0]) {
      modal2.css("display", "none");
    }
  });

  
  var modal3 = $("#myModal3");
  var btn3 = $("#myBtn3");
  var span = $(".close").eq(0);

  if (btn3.length > 0) {
    btn3.on("click", function() {
      modal3.css("display", "block");
    });
  }
  span.on("click", function() {
    modal3.css("display", "none");
  });
  $(window).on("click", function(event) {
    if (event.target === modal3[0]) {
      modal3.css("display", "none");
    }
  });


  function fixavis(){
      $("[lang='fr'] .template-product .jdgm-prev-badge__text").each(function() {
      var text = $(this).text().replace("reviews", "avis");
      $(this).html(text);
    });
  }
  
  fixavis();
  setInterval(function() {
    fixavis();
  }, 1000);




 $(".best-sellers-block").each(function(){
    $(this).find(".xslide").remove();
    $(this).find(".xslide-track").remove();
    $(this).find(".slider-blocks").append("<span class='xslide'><em></em></span>");
    $(this).find(".slider-blocks").append("<span class='xslide-track'></span>");
    var xslide = $(this).find(".xslide em");
    var innerElement = $(this).find(".slider-inner")[0];
    var track = $(this).find(".xslide-track");

    // Update xslide position on scroll
    innerElement.addEventListener('scroll', () => {
        const innerScrollX = innerElement.scrollLeft;
        const maxScrollX = innerElement.scrollWidth - innerElement.clientWidth;
        var scrollPercentage = ((innerScrollX / maxScrollX) * 100) * 90 / 100;
        xslide.css("left", scrollPercentage + "%");
    });

    // Enable dragging the xslide bar
    let isDragging = false;
    let startX;
    let startScrollLeft;

    xslide.on('mousedown', function(e) {
        isDragging = true;
        startX = e.pageX;

        startScrollLeft = innerElement.scrollLeft;
        $("body").addClass("no-select");
        e.preventDefault();
    });

    $(document).on('mousemove', function(e) {
        if (!isDragging) return;
        
        const deltaX = e.pageX - startX;
        const maxScrollX = innerElement.scrollWidth - innerElement.clientWidth;
        const trackWidth = track.width(); 

        const scrollAmount = (deltaX / trackWidth) * maxScrollX;
        const newScrollLeft = startScrollLeft + scrollAmount;

        innerElement.scrollLeft = Math.max(0, Math.min(maxScrollX, newScrollLeft));

        const newLeftPercentage = (innerElement.scrollLeft / maxScrollX) * 90; 
        xslide.css("left", newLeftPercentage + "%");
    });

    $(document).on('mouseup', function() {
        if (isDragging) {
            isDragging = false;
            $("body").removeClass("no-select");
        }
    });

    track.on('click', function(e) {
        if ($(e.target).is(xslide)) {
            return;
        }
        
        const trackOffset = track.offset().left;
        const clickPositionX = e.pageX - trackOffset;
        const trackWidth = track.width();
        const newLeftPercentage = (clickPositionX / trackWidth) * 100;

        const boundedPercentage = Math.max(0, Math.min(90, newLeftPercentage));

        const maxScrollX = innerElement.scrollWidth - innerElement.clientWidth;
        const targetScrollLeft = (boundedPercentage / 90) * maxScrollX;

        $(innerElement).animate({
            scrollLeft: targetScrollLeft
        }, 250); 

        xslide.animate({
            left: boundedPercentage + "%"
        }, 250);
    });

});


  
});

